import { render, staticRenderFns } from "./MoAsiede.vue?vue&type=template&id=c8983966&scoped=true"
import script from "./MoAsiede.vue?vue&type=script&lang=js"
export * from "./MoAsiede.vue?vue&type=script&lang=js"
import style0 from "./MoAsiede.vue?vue&type=style&index=0&id=c8983966&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8983966",
  null
  
)

export default component.exports